import { IMAGES } from "../lib/site";
import { Reveal } from "./Reveal";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#F9F9F6] py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20">
        {/* Left: image stack */}
        <div className="md:col-span-5 lg:col-span-5 order-2 md:order-1">
          <Reveal>
            <div className="relative">
              <img
                src={IMAGES.about}
                alt="Rider with horse"
                className="w-full aspect-[4/5] object-cover"
                loading="lazy"
              />
              <div className="absolute -bottom-8 -right-4 md:-right-10 bg-[#1A2B22] text-[#F9F9F6] py-6 px-6 max-w-[260px]">
                <p className="font-display text-4xl tracking-tighter leading-none">
                  Est. 2026
                </p>
                <p className="mt-2 text-[11px] uppercase tracking-[0.28em] text-[#F9F9F6]/70">
                  A New Standard in Coconut Creek
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        {/* Right: editorial copy */}
        <div className="md:col-span-7 lg:col-span-6 lg:col-start-7 order-1 md:order-2">
          <Reveal>
            <p
              data-testid="about-eyebrow"
              className="text-[11px] uppercase tracking-[0.32em] text-[#965C3B]"
            >
              About — SPJ Sporthorses
            </p>
          </Reveal>

          <Reveal delay={120}>
            <h2
              data-testid="about-heading"
              className="mt-6 font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95] text-[#1A2B22]"
            >
              A discerning eye for
              <br />
              <em className="italic font-normal text-[#965C3B]">
                exceptional
              </em>{" "}
              warmbloods.
            </h2>
          </Reveal>

          <Reveal delay={220}>
            <div className="mt-10 space-y-6 text-[#1A2B22]/80 leading-relaxed max-w-xl">
              <p>
                Founded in 2026 in the heart of South Florida's equestrian
                community, SPJ Sporthorses is a boutique training and
                brokerage program specializing in premium Czech Warmbloods.
                We bridge the gap between Europe's most refined breeding
                programs and the competitive North American show circuit.
              </p>
              <p>
                Every horse we represent is hand-selected, personally
                evaluated, and developed with patience and precision —
                producing partners that excel in the hunter, jumper, and
                equitation rings.
              </p>
            </div>
          </Reveal>

          <Reveal delay={320}>
            <div className="mt-12 grid grid-cols-2 gap-6 max-w-md">
              <div className="border-t hairline pt-5">
                <p className="font-display text-3xl tracking-tighter text-[#1A2B22]">
                  Hunters
                </p>
                <p className="mt-1 text-xs uppercase tracking-[0.22em] text-[#5C6A61]">
                  Quiet, scopey, confident
                </p>
              </div>
              <div className="border-t hairline pt-5">
                <p className="font-display text-3xl tracking-tighter text-[#1A2B22]">
                  Jumpers
                </p>
                <p className="mt-1 text-xs uppercase tracking-[0.22em] text-[#5C6A61]">
                  Brave, careful, modern
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
